/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfOrderDtoFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfOrderDto } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/vendors/{vendorCode}/orders
 */
export interface OrdersRequestBuilder extends BaseRequestBuilder<OrdersRequestBuilder> {
    /**
     * Pages the orders placed with this vendor, newest first. A vendor with no orders yet is a success with an empty page; the 404 means the vendor itself is unknown. To filter further use GET api/orders with a vendorCode or orderBatchId filter. Admins of an agency organization only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfOrderDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<OrdersRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfOrderDto | undefined>;
    /**
     * Pages the orders placed with this vendor, newest first. A vendor with no orders yet is a success with an empty page; the 404 means the vendor itself is unknown. To filter further use GET api/orders with a vendorCode or orderBatchId filter. Admins of an agency organization only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<OrdersRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Pages the orders placed with this vendor, newest first. A vendor with no orders yet is a success with an empty page; the 404 means the vendor itself is unknown. To filter further use GET api/orders with a vendorCode or orderBatchId filter. Admins of an agency organization only.
 */
export interface OrdersRequestBuilderGetQueryParameters {
    /**
     * Which page to return, counting from 1.
     */
    pageNumber?: number;
    /**
     * How many orders per page, 1 to 500.
     */
    pageSize?: number;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const OrdersRequestBuilderUriTemplate = "{+baseurl}/api/vendors/{vendorCode}/orders?pageNumber={pageNumber}&pageSize={pageSize}{&useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const OrdersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: OrdersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfOrderDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
